import { render } from "./ConvocationComponent.vue?vue&type=template&id=71a5dd78"
import script from "./ConvocationComponent.vue?vue&type=script&lang=js"
export * from "./ConvocationComponent.vue?vue&type=script&lang=js"

import "./ConvocationComponent.vue?vue&type=style&index=0&id=71a5dd78&lang=scss"

import exportComponent from "/home/runner/work/schFront/schFront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__